import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'

defineRule('fillableIfFieldIsSet', (value, [target], { field }) => {
  if (!(value && (!target || target === ''))) {
    return true
  }
  return i18n.global.t('validation.fillableIfFieldIsSet', { field })
})
